<div class="_event-details-mobile-component">
    
    <div class="_scroll">
        <ng-container *ngIf="controller.event">
            <div class="_header">
                <p class="_title" >{{controller.event.name}} ({{controller.event.EventType.name}})</p>
                <p class="_subtitle _ended" *ngIf="controller.isInPast">{{'EVENT.ENDED' | translate}}</p>
            </div>
    
            <div class="_info">	
                <ng-container *ngIf="controller.event.attendanceType !== controller.EventAttendanceType.Lessons; else lessons">
                    <info-line icon="./assets/icons/calendar-outline.svg" align="top">
                        <p>{{controller.calendarEvent.startsAt | date:'E dd/MM/yyyy'}} | 
                            {{controller.calendarEvent.startsAt | date:"HH:mm"}} - {{controller.calendarEvent.endsAt | date:"HH:mm"}} |
                            <ng-container [ngSwitch]="controller.event.interval">
                                <span *ngSwitchCase="controller.EventInterval.OneTime">{{'EVENT_INTERVAL.ONETIME' | translate}}</span>
                                <span *ngSwitchCase="controller.EventInterval.Daily">{{'EVENT_INTERVAL.DAILY' | translate}}</span>
                                <span *ngSwitchCase="controller.EventInterval.Weekly">{{'EVENT_INTERVAL.WEEKLY' | translate}}</span>
                                <span *ngSwitchCase="controller.EventInterval.Monthly">{{'EVENT_INTERVAL.MONTHLY' | translate}}</span>
                            </ng-container>
                        </p>
                    </info-line>
                </ng-container>
    
                <ng-template #lessons>
                    <info-line icon="./assets/icons/calendar-outline.svg" align="top">
                        <p>{{'EVENT_ATTENDANCE_TYPE.LESSONS' | translate}}:</p>
                        <div *ngFor="let lesson of controller.event.Lessons" class="_lessons">
                            <div class="_lesson">
                                <p class="_label">
                                    <b>{{lesson.name}}:</b> {{lesson.CalendarEvent.startsAt | date:"EEEE dd/MM/yyyy"}} | {{lesson.CalendarEvent.startsAt | date:"HH:mm"}} - {{lesson.CalendarEvent.endsAt | date:"HH:mm"}}
                                </p>
                            </div>
                        </div>					     
                    </info-line>
                </ng-template>
    
                <ng-container *ngIf="controller.event.locationType === controller.EventLocationType.OnLocation">
                    <info-line icon="./assets/icons/location-outline.svg" align="top">
                        <p><b>{{controller.event.Location?.place}}</b></p>
                        <p [navigate]="[controller.InternalNavigationType.address, controller.event.Location?.Address]">{{controller.event.Location?.Address | address}}</p>
                    </info-line>
                </ng-container>
                    
                <ng-container *ngIf="controller.event.locationType === controller.EventLocationType.Online">
                    <info-line icon="./assets/icons/online-event-outline.svg" align="top">
                        <p><b [translate]="'EVENT.IS_ONLINE_EVENT'"></b></p>
                        <p class="_url" [navigate]="[controller.InternalNavigationType.url, controller.event.url]">{{controller.event.url}}</p>
                    </info-line>
                </ng-container>
                        
                <info-line icon="./assets/icons/loan-outline.svg" align="top" *ngIf="controller.event.isLoanLocation">
                    <p [translate]="'EVENT.IS_LOAN_LOCATION'"></p>
                </info-line>
    
                <info-line icon="./assets/icons/info-outline.svg" *ngIf="controller.event.description">
                    <p><b>{{'EVENT.DESCRIPTION' | translate}}</b> {{controller.event.description}}</p>
                </info-line>			
    
                <info-line icon="./assets/icons/attendance-type-outline.svg" align="top" *ngIf="!controller.EventAttendanceType.Lessons">
                    <p><b [translate]="'EVENT.ATTENDANCE_TYPE_TITLE'"></b>
                        <ng-container [ngSwitch]="controller.event.attendanceType">
                            <span *ngSwitchCase="controller.EventAttendanceType.Reservation"> {{'EVENT_ATTENDANCE_TYPE.RESERVATION' | translate}}</span>
                            <span *ngSwitchCase="controller.EventAttendanceType.Registration"> {{'EVENT_ATTENDANCE_TYPE.REGISTRATION' | translate}}</span>
                            <span *ngSwitchCase="controller.EventAttendanceType.WalkIn"> {{'EVENT_ATTENDANCE_TYPE.WALKIN' | translate}}</span>
                        </ng-container>
                    </p>
                </info-line>	
                
                <info-line icon="./assets/icons/agency-outline.svg" align="top">
                    <p><b [translate]="'EVENT.DIGIBANK_AGENCY'"></b> {{controller.event.DigibankAgency.name}}</p>
                </info-line>
    
                <info-line icon="./assets/icons/employees-outline.svg" align="top" *ngIf="controller.event.attendanceType === controller.EventAttendanceType.Registration">
                    <p><b [translate]="'EVENT.MAX_REGISTRATIONS'"></b> 
                        <span *ngIf="controller.event.maxRegistrations"> {{controller.event.maxRegistrations}}</span>
                        <span *ngIf="!controller.event.maxRegistrations" [translate]="'EVENT.NO_MAX_REGISTRATIONS'"></span>
                    </p>	
                </info-line>
    
                <info-line icon="./assets/icons/employees-outline.svg" align="top">
                    <p><b [translate]="'EVENT.EMPLOYEES_TITLE'"></b> {{controller.event.Employees | arrayValue:['firstname', 'lastname']}}</p>
                </info-line>       
            </div>	
        </ng-container>  
        
    
        <ng-container *ngIf="controller.event">
    
            <div class="_right_header">
                <p class="_title" *ngIf="controller.event.attendanceType === controller.EventAttendanceType.Reservation" [translate]="'EVENT_DETAILS.RESERVATIONS'"></p>
                <p *ngIf="controller.event.attendanceType === controller.EventAttendanceType.Registration || controller.event.attendanceType === controller.EventAttendanceType.Lessons">{{'EVENT_DETAILS.REGISTRATIONS' | translate}} 
                    <ng-container *ngIf="controller.event.maxRegistrations">
                        <span>{{((controller.event.Reservations ?? []) | filter:true:['isActive']).length}} / {{controller.event.maxRegistrations}}</span>
                        <span *ngIf="(((controller.event.Reservations ?? []) | filter:true:['isActive']).length || 0) >= controller.event.maxRegistrations"> ({{'EVENT_DETAILS.FULLY_BOOKED' | translate}})</span>
                    </ng-container>
                </p>
                <p *ngIf="controller.event.attendanceType === controller.EventAttendanceType.WalkIn && !controller.attendancesVisible" [translate]="'EVENT_DETAILS.WALKIN_INFO'"></p>
            </div>
    
            <div class="_event-details">
    
                <!-- Reservations and Registrations -->
                <div class="_reservations-container" *ngIf="controller.event.attendanceType !== controller.EventAttendanceType.WalkIn">
                    
                    <!-- Loop over not cancelled items -->
    
                    <div class="_reservation" *ngFor="let reservation of controller.event.Reservations | filter:true:['isActive']"  [ngClass]="{'_free': !reservation.Client, '_reserved': reservation.Client, '_in-past': controller.isInPast}"  (click)="!reservation.Client && controller.openReservation(reservation)">
                        <div class="_time" *ngIf="controller.event.attendanceType === controller.EventAttendanceType.Reservation" [ngClass]="{'_is-reserved': reservation.Client}">
                            {{reservation.startsAt | date:"HH:mm"}} - {{reservation.endsAt | date:"HH:mm"}}
                            <span class="_status">
                                <span *ngIf="reservation.Client">
                                    ({{'RESERVATION.RESERVED' | translate}})
                                </span>
                                <span *ngIf="!reservation.Client">
                                    ({{'RESERVATION.FREE' | translate}})
                                </span>
                            </span>
                        </div>
    
                        <div class="_extra-info" *ngIf="reservation.Client">	
                            <info-line icon="./assets/icons/user-outline.svg">
                                <p>{{reservation.Client.firstname}} {{reservation.Client.lastname}}</p>
                            </info-line>
                            <info-line *ngIf="reservation.Client.telephone" icon="./assets/icons/phone-outline.svg">
                                <p>{{reservation.Client.telephone}}</p>
                            </info-line>
                            <info-line  *ngIf="reservation.Client.email" icon="./assets/icons/email-outline.svg">
                                <p>{{reservation.Client.email}}</p>
                            </info-line>

                            @if (reservation.Rating) {
                                <div class="_rating-container">
    
                                    <p class="_title" [translate]="'RESERVATION.RATING'"></p>
    
                                    <info-line icon="./assets/icons/rating-outline.svg" class="_rating-score-container">
                                        <p class="_rating-score">
                                            <span class="_rating-score-star-container">
                                                @for (i of [1,2,3,4,5]; track $index) {
                                                    @if (reservation.Rating.score >= i) {
                                                        <ion-icon src="./assets/icons/star.svg"></ion-icon>
                                                    } @else {
                                                        <ion-icon style="color: lightgrey" src="./assets/icons/star-outline.svg"></ion-icon>
                                                    }
                                                    
                                                }
                                            </span>
                                        </p>
                                    </info-line>
    
                                    @if (reservation.Rating.note) {
                                        <info-line icon="./assets/icons/chat-outline.svg">
                                            <p>{{reservation.Rating.note}}</p>
                                        </info-line>
                                    }
    
                                </div>
                            }
                        </div>
    
                        <!-- Attendance checkbox is visible from the day of the event-->
                        <div class="_attendance" *ngIf="reservation.Client && controller.attendancesVisible" (click)="controller.changeAttendanceStatus(reservation);$event.stopPropagation()">
                            <label for="">{{'RESERVATION.PRESENT' | translate}}</label>
                            <span>
                                <input type="checkbox" checked *ngIf="reservation.Attendance.status === controller.AttendanceStatus.Present; else absent" />
                                <ng-template #absent><input type="checkbox" /></ng-template>
                            </span>
                        </div>
                    </div>
    
                    <ng-container *ifUserHasPermissions="[controller.UserPermissions.WriteWaitList]">
                        <div class="_reservation _add-to-wait-list" *ngIf="!controller.isInPast && controller.eventIsFullyBooked()" (click)="controller.openWaitList()">
                            <ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
                            <span>{{'EVENT_DETAILS.ADD_TO_WAIT_LIST' | translate}}</span>
                        </div>
                    </ng-container>

                    <!-- Loop over wait list items -->
                    <ng-container *ifUserHasPermissions="[controller.UserPermissions.WriteWaitList]">
                        <ng-container *ngIf="controller.event.WaitListItems?.length > 0">
                            <p class="_wait-list-title">
                                {{'EVENT_DETAILS.WAIT_LIST_ITEMS' | translate}} 
                                <span>({{controller.event.WaitListItems.length}})</span>
                            </p>
        
                            <div class="_reservation _wait-list" *ngFor="let waitListItem of controller.event.WaitListItems" (click)="controller.openReservationFromWaitList(waitListItem)">
        
                                <p class="_wait-list-title">
                                    <b>{{'EVENT_DETAILS.WAIT_LIST_ITEMS' | translate}}</b>
                                    <span> - {{waitListItem.createdAt | date:"dd/MM/yyyy"}} {{'AT' | translate}} {{waitListItem.createdAt | date:"HH:mm"}}</span>
                                </p>
        
                                <p class="_wait-list-info" *ngIf="waitListItem.description">
                                    <span>{{waitListItem.description}}</span>
                                </p>
        
                                <div class="_extra-info" *ngIf="waitListItem.Client">	
                                    <info-line icon="./assets/icons/user-outline.svg">
                                        <p>{{waitListItem.Client.firstname}} {{waitListItem.Client.lastname}}</p>
                                    </info-line>
                                    <info-line *ngf="waitListItem.Client.telephone" icon="./assets/icons/phone-outline.svg">
                                        <p>{{waitListItem.Client.telephone}}</p>
                                    </info-line>
                                    <info-line *ngIf="waitListItem.Client.email" icon="./assets/icons/email-outline.svg">
                                        <p>{{waitListItem.Client.email}}</p>
                                    </info-line>
                                </div>
        
                            </div>
                        </ng-container>
                    </ng-container>
    
                    <!-- Loop over cancelled items -->
                    <ng-container *ngIf="((controller.event.Reservations ?? []) | filter:false:['isActive']).length">
                        <p class="_cancellations-title">
                            {{'EVENT_DETAILS.CANCELLATIONS' | translate}} 
                            <span>({{((controller.event.Reservations ?? []) | filter:false:['isActive']).length}})</span>
                        </p>
    
                        <div class="_reservation _cancelled" *ngFor="let reservation of controller.event.Reservations | filter:false:['isActive']" >
                            
                            <p class="_cancellation-title">
                                <b>{{'EVENT_DETAILS.IS_CANCELLED' | translate}}</b>
                                <span *ngIf="reservation.cancelledAt"> {{'ON_THE' | translate}} {{reservation.cancelledAt | date:"dd/MM/yyyy"}} {{'AT' | translate}} {{reservation.cancelledAt | date:"HH:mm"}}</span>
                            </p>
    
                            <p class="_cancellation-info" *ngIf="reservation.cancellationInfo || reservation.CancellationReason?.name">
                                <span>{{reservation.CancellationReason?.name}}</span>
                                <span *ngIf="reservation.cancellationInfo && reservation.CancellationReason?.name"> - </span>
                                <span>{{reservation.cancellationInfo}}</span>
                            </p>
    
                            <div class="_extra-info" *ngIf="reservation.Client">	
                                <info-line icon="./assets/icons/user-outline.svg">
                                    <p>{{reservation.Client.firstname}} {{reservation.Client.lastname}}</p>
                                </info-line>
                                <info-line *ngIf="reservation.Client.telephone" icon="./assets/icons/phone-outline.svg">
                                    <p>{{reservation.Client.telephone}}</p>
                                </info-line>
                                <info-line *ngIf="reservation.Client.email" icon="./assets/icons/email-outline.svg">
                                    <p>{{reservation.Client.email}}</p>
                                </info-line>
                            </div>
    
                        </div>
                    </ng-container>
    
                </div>
    
                <!-- Walkin Attendances-->
                <div class="_walkin_attendances" *ngIf="controller.event.attendanceType === controller.EventAttendanceType.WalkIn && controller.attendancesVisible && controller.walkInAttendanceForm">
                    
                    <!-- Walkin attendances - registered -->
                    
                        <p class="_title">{{'EVENT_DETAILS.WALKIN_CLIENTS' | translate}}</p>
                        
                        <!-- List registered visitors -->
                        <div class="_reservations-container">
                            <!-- Loop over items -->
                            <div class="_reservation" *ngFor="let reservation of ((controller.event.Reservations ?? []) | filter:true:['isActive'])" [ngClass]="{'_free': !reservation.Client, '_reserved': reservation.Client, '_in-past': controller.isInPast}" >
                                <div class="_extra-info" *ngIf="reservation.Client">	
                                    <info-line icon="./assets/icons/user-outline.svg">
                                        <p>{{reservation.Client.firstname}} {{reservation.Client.lastname}}</p>
                                    </info-line>
                                    <info-line icon="./assets/icons/phone-outline.svg">
                                        <p>{{reservation.Client.telephone}}</p>
                                    </info-line>
                                    <info-line icon="./assets/icons/email-outline.svg">
                                        <p>{{reservation.Client.email}}</p>
                                    </info-line>
                                </div>
                            </div>
                        </div>
                   
                </div>
            </div>
        </ng-container>
    </div>


    
   
   
    <!-- BUTTONS -->
    <div class="_buttons">
        <!-- BUTTONS REGISTRATION-->
        <!-- Registrations are open until the end of the same day  -->
        <ng-container  *ngIf="controller.event?.attendanceType === controller.EventAttendanceType.Registration">
            <button  class="_button _save-button" [ngClass]="{'_neutral-button': (((controller.event.Reservations ?? []) | filter:true:['isActive'])?.length || 0) >= controller.event.maxRegistrations  }" [translate]="('REGISTRATION.ADD_REGISTRATION')" (click)="controller.openReservation()"></button>
            <button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="controller.close()"></button>
        </ng-container>	

        <!-- BUTTONS LESSONS-->
        <!-- Registrations are open until the end of the same day  -->

        <ng-container  *ngIf="controller.event?.attendanceType === controller.EventAttendanceType.Lessons">
            <button  class="_button _save-button" [ngClass]="{'_neutral-button': ((controller.event.Reservations ?? []) | filter:true:['isActive'])?.length > controller.event.maxRegistrations }" [translate]="'EVENT.LESSONS.REGISTER'" (click)="controller.openReservation()"></button>
            <button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="controller.close()"></button>
        </ng-container>			

        <!-- BUTTONS RESERVATION -->
        <ng-container  *ngIf="controller.event?.attendanceType === controller.EventAttendanceType.Reservation">
            <button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="controller.close()"></button>
        </ng-container>


        <!-- BUTTONS WALKIN -->
        <ng-container  *ngIf="controller.event?.attendanceType === controller.EventAttendanceType.WalkIn">  
            <!-- ATTENDANCE-->
            <button  class="_button _save-button" [translate]="'REGISTRATION.ADD_CLIENT'" (click)="controller.openWalkInReservation()"></button>
            <button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="controller.close()"></button>
        </ng-container>	
    </div>

</div>